export const Navigation = (props) => {

  return (
    <nav id='menu' className='navbar navbar-default navbar-fixed-top'>
      <div className='container'>
        <div className='navbar-header'>
          <button
            type='button'
            className='navbar-toggle collapsed'
            data-toggle='collapse'
            
            data-target='#bs-example-navbar-collapse-1'
          >
            {' '}
            <span className='sr-only'></span>{' '}
            <span className='icon-bar'></span>{' '}
            <span className='icon-bar'></span>{' '}
            <span className='icon-bar'></span>{' '}
          </button>
          <a className='navbar-brand page-scroll' href='#page-top'>
            <img className='navbar-img'
              src= { 'ontouchstart' in document.documentElement ? 'img/logo/ygzsoftware_mobile.png' : 'img/logo/ygzsoftware.png'}           
              alt={props.data ? props.data.title : 'Loading'}              
            />{' '}
          </a>{' '}
        </div>

        <div
          className='collapse navbar-collapse'
          id='bs-example-navbar-collapse-1'
        >
          <ul className='nav navbar-nav navbar-right'>
          <li>
              <a href='#services' className='page-scroll'>
                {props.data ? props.data.menu1 : 'Loading'}
              </a>
            </li>
            <li>
              <a href='#about' className='page-scroll'>
                {props.data ? props.data.menu2 : 'Loading'}
              </a>
            </li>
            <li>
              <a href='#contact' className='page-scroll'>
                {props.data ? props.data.menu3 : 'Loading'}
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  )
}
